$(document).ready(function () {
  // toggle sidebar
  $nav = $('.main-nav');
  $header = $('.page-main-header');
  $toggle_nav_top = $('#sidebar-toggle');
  $toggle_nav_top.click(function() {
    $this = $(this);
    $nav = $('.main-nav');
    $nav.toggleClass('close_icon');
    $header.toggleClass('close_icon');
  });

  $(".toggle-nav").click(function () {
    $('.nav-menu').css("left", "0px");
  });
  $(".mobile-back").click(function () {
    $('.nav-menu').css("left", "-410px");
  });

  $(".page-wrapper").attr("class", "page-wrapper "+localStorage.getItem("page-wrapper"));
  $(".page-body-wrapper").attr("class", "page-body-wrapper "+localStorage.getItem("page-body-wrapper"));

  if (localStorage.getItem("page-wrapper") === null) {
    $(".page-wrapper").addClass("compact-wrapper");
  }

  // left sidebar and horizotal menu
  if($('#pageWrapper').hasClass('compact-wrapper')){
    $('.submenu-title').append('<div class="according-menu"><i class="fa fa-angle-right"></i></div>');
    $('.submenu-title').click(function () {
      $('.submenu-title').removeClass('active');
      $('.submenu-title').find('div').replaceWith('<div class="according-menu"><i class="fa fa-angle-right"></i></div>');
      $('.submenu-content').slideUp('normal');
      if ($(this).next().is(':hidden') == true) {
        $(this).addClass('active');
        $(this).find('div').replaceWith('<div class="according-menu"><i class="fa fa-angle-down"></i></div>');
        $(this).next().slideDown('normal');
      } else {
        $(this).find('div').replaceWith('<div class="according-menu"><i class="fa fa-angle-right"></i></div>');
      }
    });
    $('.submenu-content').hide();

    $('.menu-title').append('<div class="according-menu"><i class="fa fa-angle-right"></i></div>');
    $('.menu-title').click(function () {
      $('.menu-title').removeClass('active');
      $('.menu-title').find('div').replaceWith('<div class="according-menu"><i class="fa fa-angle-right"></i></div>');
      $('.menu-content').slideUp('normal');
      if ($(this).next().is(':hidden') == true) {
        $(this).addClass('active');
        $(this).find('div').replaceWith('<div class="according-menu"><i class="fa fa-angle-down"></i></div>');
        $(this).next().slideDown('normal');
      } else {
        $(this).find('div').replaceWith('<div class="according-menu"><i class="fa fa-angle-right"></i></div>');
      }
    });
    $('.menu-content').hide();
  } else if ($('#pageWrapper').hasClass('horizontal-wrapper')) {
    var contentwidth = $(window).width();
    if ((contentwidth) < '992') {
      $('#pageWrapper').removeClass('horizontal-wrapper').addClass('compact-wrapper');
      $('.page-body-wrapper').removeClass('horizontal-menu').addClass('sidebar-icon');
      $('.submenu-title').append('<div class="according-menu"><i class="fa fa-angle-right"></i></div>');
      $('.submenu-title').click(function () {
        $('.submenu-title').removeClass('active');
        $('.submenu-title').find('div').replaceWith('<div class="according-menu"><i class="fa fa-angle-right"></i></div>');
        $('.submenu-content').slideUp('normal');
        if ($(this).next().is(':hidden') == true) {
          $(this).addClass('active');
          $(this).find('div').replaceWith('<div class="according-menu"><i class="fa fa-angle-down"></i></div>');
          $(this).next().slideDown('normal');
        } else {
          $(this).find('div').replaceWith('<div class="according-menu"><i class="fa fa-angle-right"></i></div>');
        }
      });
      $('.submenu-content').hide();

      $('.menu-title').append('<div class="according-menu"><i class="fa fa-angle-right"></i></div>');
      $('.menu-title').click(function () {
        $('.menu-title').removeClass('active');
        $('.menu-title').find('div').replaceWith('<div class="according-menu"><i class="fa fa-angle-right"></i></div>');
        $('.menu-content').slideUp('normal');
        if ($(this).next().is(':hidden') == true) {
          $(this).addClass('active');
          $(this).find('div').replaceWith('<div class="according-menu"><i class="fa fa-angle-down"></i></div>');
          $(this).next().slideDown('normal');
        } else {
          $(this).find('div').replaceWith('<div class="according-menu"><i class="fa fa-angle-right"></i></div>');
        }
      });
      $('.menu-content').hide();
    }
  }

  $body_part_side = $('.body-part');
  $body_part_side.click(function(){
    $toggle_nav_top.attr('checked', false);
    $nav.addClass('close_icon');
    $header.addClass('close_icon');
  });

  // document sidebar
  $('.mobile-sidebar').click(function(){
    $('.document').toggleClass('close')
  });

  var $window = $(window);
  var widthwindow = $window.width();

  if(widthwindow+17 <= 993) {
    $toggle_nav_top.attr('checked', false);
    $nav.addClass("close_icon");
    $header.addClass("close_icon");
  }

  // page active
  $( ".main-navbar" ).find( "a" ).removeClass("active");
  $( ".main-navbar" ).find( "li" ).removeClass("active");

  var current = window.location.pathname
  $(".main-navbar ul>li a").filter(function() {

    var link = $(this).attr("href");
    if(link && link != '/admin') {
      if (current.indexOf(link) != -1) {
        $(this).parents().children('a').addClass('active');
        $(this).parents().parents().children('ul').css('display', 'block');
        $(this).addClass('active');
        $(this).parent().parent().parent().children('a').find('div').replaceWith('<div class="according-menu"><i class="fa fa-angle-down"></i></div>');
        $(this).parent().parent().parent().parent().parent().children('a').find('div').replaceWith('<div class="according-menu"><i class="fa fa-angle-down"></i></div>');
        return false;
      }
    }
  });

  // horizontal arrows
  var view = $("#mainnav");
  var move = "0px";
  var leftsideLimit = 0

  // var Windowwidth = $(window).width();
  // get wrapper width
  var getMenuWrapperSize = function () {
    return $('.sidebar-wrapper').innerWidth();
  }
  var menuWrapperSize = getMenuWrapperSize();

  if ((menuWrapperSize) >= '1660') {
    var sliderLimit = -3000

  } else if ((menuWrapperSize) >= '1440') {
    var sliderLimit = -3600
  } else {
    var sliderLimit = -4200
  }

  $("#left-arrow").addClass("disabled");
  $("#right-arrow").click(function () {
    var currentPosition = parseInt(view.css("marginLeft"));
    if (currentPosition >= sliderLimit) {
      $("#left-arrow").removeClass("disabled");
      view.stop(false, true).animate({
        marginLeft: "-=" + move
      }, {
        duration: 400
      })
      if (currentPosition == sliderLimit) {
        $(this).addClass("disabled");
      }
    }
  });

  $("#left-arrow").click(function () {
    var currentPosition = parseInt(view.css("marginLeft"));
    if (currentPosition < 0) {
      view.stop(false, true).animate({
        marginLeft: "+=" + move
      }, {
        duration: 400
      })
      $("#right-arrow").removeClass("disabled");
      $("#left-arrow").removeClass("disabled");
      if (currentPosition >= leftsideLimit) {
        $(this).addClass("disabled");
      }
    }
  });
});

$(window).resize(function() {
  var $window = $(window);
  var widthwindow = $window.width();
  $nav = $('.main-nav');
  $header = $('.page-main-header');
  $toggle_nav_top = $('#sidebar-toggle');
  $toggle_nav_top.click(function() {
    $this = $(this);
    $nav = $('.main-nav');
    $nav.toggleClass('close_icon');
    $header.toggleClass('close_icon');
  });

  var widthwindaw = $window.width();
  if(widthwindaw+17 <= 991) {
    $toggle_nav_top.attr('checked', false);
    $nav.addClass("close_icon");
    $header.addClass("close_icon");
  }
  else {
    $toggle_nav_top.attr('checked', true);
    $nav.removeClass("close_icon");
    $header.removeClass("close_icon");
  }
});